var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "expansion-panel",
    class: {
      'expansion-panel_content-visible': _vm.contentVisible
    }
  }, [_c('div', {
    staticClass: "expansion-panel__header",
    class: {
      'expansion-panel__header_block': _vm.headerBlock
    },
    attrs: {
      "tabindex": "0",
      "role": "button",
      "aria-expanded": _vm.contentVisible
    },
    on: {
      "click": _vm.toggleContentVisible,
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter") && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        return _vm.toggleContentVisible.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "expansion-panel__caption"
  }, [_vm._t("caption", null, {
    "contentVisible": _vm.contentVisible
  })], 2), _c('div', {
    staticClass: "expansion-panel__icon-wrapper"
  }, [_vm._t("icon", function () {
    return [_c('chevron-down-icon')];
  })], 2)]), _c('a-transition-expand', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.contentVisible,
      expression: "contentVisible"
    }],
    staticClass: "expansion-panel__content-wrapper"
  }, [_c('div', {
    staticClass: "expansion-panel__content"
  }, [_vm._t("default")], 2)])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }